@for (option of options(); track option.value) {
  <div class="wrapper" (click)="changeValue(option)">
    <div class="radio-button">
      <div class="wave"></div>
      <div class="check" [class.checked]="option.value === selectedOption()?.value"></div>
    </div>
    <p class="body-md">{{ option.label }}</p>
  </div>
}
